"use strict";
/**
 * Created by anania.mikaelyan on 12/15/16.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var LockData = /** @class */ (function () {
    function LockData(_categoryId, _entityId, _entityName, _userId, _userFullName, _timestamp, _sessionKey) {
        this._categoryId = _categoryId;
        this._entityId = _entityId;
        this._entityName = _entityName;
        this._userId = _userId;
        this._userFullName = _userFullName;
        this._timestamp = _timestamp;
        this._sessionKey = _sessionKey;
    }
    LockData.prototype.getIsLocked = function () {
        return this._userId !== null;
    };
    Object.defineProperty(LockData.prototype, "categoryId", {
        get: function () {
            return this._categoryId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LockData.prototype, "entityId", {
        get: function () {
            return this._entityId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LockData.prototype, "entityName", {
        get: function () {
            return this._entityName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LockData.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LockData.prototype, "userFullName", {
        get: function () {
            return this._userFullName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LockData.prototype, "timestamp", {
        get: function () {
            return this._timestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LockData.prototype, "sessionKey", {
        get: function () {
            return this._sessionKey;
        },
        enumerable: true,
        configurable: true
    });
    return LockData;
}());
exports.LockData = LockData;
//# sourceMappingURL=lock-data.model.js.map